import { Box, Icon, IconButton, Stack, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useOffersStore } from "../../store"

type Props = {
    totalPages: number
    disabled: boolean
}

export function CarouselPagination({ totalPages, disabled }: Props) {
    const { translateText } = useLocalization()
    const { setCurrentCarouselPageIndex, currentCarouselPageIndex } = useOffersStore()

    function previousPage() {
        let page = currentCarouselPageIndex - 1

        if (page < 0) {
            page = totalPages - 1
        }

        setCurrentCarouselPageIndex(page)
    }

    function nextPage() {
        let page = currentCarouselPageIndex + 1

        if (page >= totalPages) {
            page = 0
        }

        setCurrentCarouselPageIndex(page)
    }

    return (
        <Box display="grid" gridTemplateColumns="1fr 1fr 1fr" alignItems="center">
            <Box />
            <Stack direction="row" flex={1} justifyContent="center" gap={2}>
                <IconButton color="primary" disabled={totalPages <= 1 || disabled} onClick={previousPage} size="small">
                    <Icon name="arrow-left" />
                </IconButton>
                <IconButton color="primary" disabled={totalPages <= 1 || disabled} onClick={nextPage} size="small">
                    <Icon name="arrow-right" />
                </IconButton>
            </Stack>
            <Box display="grid" justifyContent="flex-end">
                <Typography>{`${currentCarouselPageIndex + 1} ${translateText(344)} ${totalPages}`}</Typography>
            </Box>
        </Box>
    )
}
